export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('packet', {
    component: 'fizyPaycellPacket',
    parent: 'mainWrapper',
    url: '/packet'
  });
}



// WEBPACK FOOTER //
// ./src/app/packet/packet.routes.ts